import React, { useRef } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { DropdownTopbarItemToggler } from '../dropdowns';
import CustomButton from 'src/common/components/CustomButton';
import { actions as selectMenu } from '../../../../../redux/ducks/menu';
import { actions as selectOrgano } from '../../../../../redux/ducks/selectedCollegiateBody';
import Notifications from './Notifications';
import { logOutAPI } from 'src/api/modules/auth';
import store from 'src/redux/store';
import { useClickOutside } from 'src/hooks/useClickOutside';

export function UserProfileDropdown() {
	const selectRef = useRef(null);
	const history = useHistory();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const [showDrop, setshowDrop] = React.useState(false);
	useClickOutside(setshowDrop, selectRef);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const viewAccess = [
		'ADMINISTRADOR GENERAL',
		'RESPONSABLE DE NEGOCIO',
		'SISTEMA',
		//'RESPONSABLE DE ORGANO COLEGIADO',
		//'RESPONSABLE DE SEGUIMIENTO',
	];

	const onEye = () => {
		history.push(`/mi-perfil/${user.id}`);
	};

	let resetMenu = {
		menu: {
			aside: {
				items: [
					{
						title: 'Inicio',
						icon: 'Home/Home.svg',
						slug: '/',
					},
				],
			},
		},
	};

	const onLogOut = async () => {
		const token = store.getState()?.auth?.user?.accessToken;
		const filial = localStorage.getItem('type');
		await logOutAPI
			.post({ token })
			.then((response) => {
				if (response.codigo === 'SAOC-02' && !filial) {
					dispatch(selectOrgano.setOrgano({ ...undefined }));
					dispatch(selectMenu.setMenu(resetMenu.menu));
					localStorage.clear();
				}
			})
			.catch((e) => {})
			.finally(() => {
				if (filial) {
					dispatch(selectMenu.setMenu(resetMenu.menu));
					dispatch(selectOrgano.setOrgano({ ...undefined }));
					window.location.href = '/saoc-module-web/auth/login?type=filial';
				}
			});
	};

	return (
		<>
			<Dropdown
				drop="down"
				alignRight
				onClick={() => {
					setshowDrop(!showDrop);
				}}
				show={showDrop}
				ref={selectRef}
			>
				<Dropdown.Toggle
					as={DropdownTopbarItemToggler}
					id="dropdown-toggle-user-profile"
				>
					<div
						className={
							'btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg'
						}
					>
						<div className="container">
							<div className="row">
								<span className="font-query text-dark font-size-base d-md-inline mr-1">
									Hola
								</span>
								<span className="font-query text-dark font-weight-bolder font-size-base d-md-inline mr-3">
									{user?.nombre} {user?.apellidoPaterno}
								</span>
							</div>
							<div className="row">
								{user?.organos[0].nombrePerfil !== undefined ? (
									<>
										<span className="font-query text-dark font-size-base d-md-inline mr-1">
											Tu perfil es
										</span>
										<span className="font-query text-dark font-weight-bolder font-size-base d-md-inline mr-3">
											{user?.organos[0].nombrePerfil}
										</span>
									</>
								) : (
									'  '
								)}
							</div>
						</div>
						<span className="badge badge-danger p-4" style={{ fontSize: 14 }}>
							{`${user?.usuario}`}
						</span>
					</div>
				</Dropdown.Toggle>
				<Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
					<>
						<div className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top bg-danger">
							<div className="symbol bg-white-o-15 mr-3">
								<span className="symbol-label text-danger font-weight-bold font-size-h4 ">
									{user?.nombre?.toUpperCase().charAt(0)}
								</span>
								{/*<img alt="Pic" className="hidden" src={user?.pic} />*/}
							</div>
							<div className="font-query text-white m-0 flex-grow-1 mr-3 font-size-h5 ">
								{user?.nombre} {user?.apellidoPaterno}
							</div>
						</div>
					</>

					<div className="d-flex justify-content-between p-5">
						<Link
							to="/logout"
							id="cerrar_sesion"
							className="btn btn-light-danger font-weight-bold"
							onClick={onLogOut}
						>
							Cerrar Sesión
						</Link>
						<CustomButton
							mainText="Mi Perfil"
							color="light-primary"
							onClick={() => {
								onEye();
							}}
						/>
					</div>
				</Dropdown.Menu>
			</Dropdown>
			{viewAccess.includes(systemLevelRole) === true && <Notifications />}
		</>
	);
}
